"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>PennyCaresSurvey
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const useGetSurveyContent_js_namespaceObject = require("../../hooks/useGetSurveyContent.js");
var useGetSurveyContent_js_default = /*#__PURE__*/ __webpack_require__.n(useGetSurveyContent_js_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const feedback_survey_namespaceObject = require("@pcln/feedback-survey");
const usePostSurveyContent_js_namespaceObject = require("../../hooks/usePostSurveyContent.js");
var usePostSurveyContent_js_default = /*#__PURE__*/ __webpack_require__.n(usePostSurveyContent_js_namespaceObject);
const index_js_namespaceObject = require("../Loading/index.js");
var index_js_default = /*#__PURE__*/ __webpack_require__.n(index_js_namespaceObject);
const PennyCaresSurvey_PennyCaresSurvey = ({ onClose, offerNumber })=>{
    const { submitChatMessagesPayload } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const [variables, setVariables] = (0, external_react_namespaceObject.useState)({
        encodedId: '',
        answers: void 0
    });
    const { details, isDetailsRetrieved, encodedId, loading } = useGetSurveyContent_js_default()(submitChatMessagesPayload);
    const { isAnswersSent } = usePostSurveyContent_js_default()(variables);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (isAnswersSent) {
            const offerProcessed = localStorage.getItem('PennyCaresSurveyDict');
            if (offerProcessed && 'string' == typeof offerProcessed) try {
                const parsedOfferProcessed = JSON.parse(offerProcessed);
                parsedOfferProcessed.push(offerNumber);
                localStorage.setItem('PennyCaresSurveyDict', JSON.stringify(parsedOfferProcessed));
            } catch (e) {
                localStorage.setItem('PennyCaresSurveyDict', JSON.stringify([
                    offerNumber
                ]));
            }
            else localStorage.setItem('PennyCaresSurveyDict', JSON.stringify([
                offerNumber
            ]));
        }
    }, [
        isAnswersSent
    ]);
    if (loading) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_js_default(), {});
    if (!isDetailsRetrieved && !loading) {
        onClose();
        return null;
    }
    const processScoresSubmitted = (scoresSubmitted)=>{
        const answers = [];
        const questionIds = Object.keys(scoresSubmitted);
        questionIds.forEach((id)=>{
            answers.push({
                id,
                answer: {
                    value: scoresSubmitted[id].value,
                    type: 'rating' === scoresSubmitted[id].type ? 'numeric' : 'text'
                }
            });
        });
        return answers;
    };
    async function handleSurveySubmit(scoresSubmitted) {
        const answersForSubmission = processScoresSubmitted(scoresSubmitted);
        setVariables({
            encodedId,
            answers: answersForSubmission
        });
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
        p: 4,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(feedback_survey_namespaceObject.CaresSurvey, {
            surveyDetails: details,
            submitFunction: handleSurveySubmit
        })
    });
};
const PennyCaresSurvey = PennyCaresSurvey_PennyCaresSurvey;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
